import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import {
  getEmailSettings,
  sendTestEmail,
  upsertEmailSettings,
  type EmailSettingsEnvelope,
  type SendTestResult,
  type UpsertEmailSettingsBody,
} from "../api/emailSettings";

const KEY = "email-settings";

/** Singleton email-settings envelope (§L — HTTP via TanStack Query). */
export function useEmailSettings() {
  return useQuery<EmailSettingsEnvelope>({
    queryKey: [KEY],
    queryFn: getEmailSettings,
    staleTime: 30_000,
  });
}

/** PUT upsert; refreshes the singleton cache. */
export function useUpsertEmailSettings() {
  const queryClient = useQueryClient();
  return useMutation<EmailSettingsEnvelope, Error, UpsertEmailSettingsBody>({
    mutationFn: upsertEmailSettings,
    onSuccess: (data) => {
      queryClient.setQueryData([KEY], data);
    },
  });
}

/** POST /test; resolves with `{ok:true,messageId}` or `{ok:false,stage,code,message}`. */
export function useSendTestEmail() {
  return useMutation<SendTestResult, Error, string>({
    mutationFn: sendTestEmail,
  });
}
